/**
 * 행 미수정 시 의약품명 검색어 규칙 (레거시 drugSearchKeywords.js).
 * - 원문에서 한글만 남긴 뒤 앞 4글자
 */

export const buildDrugNameSearchKeywordWhenNotEditing = (
  raw: string | null | undefined,
): string => {
  const cleaned = String(raw ?? '')
    .replace(/[A-Za-z0-9]/g, '')
    .replace(/[(){}[\]<>]/g, '')
    .replace(/[^\p{Script=Hangul}]/gu, '');
  const first4 = cleaned.slice(0, 4);
  return first4
    .replace(/[(){}[\]<>]/g, '')
    .replace(/[^\p{Script=Hangul}]/gu, '');
};

/** 검색 결과 없음일 때 모달에서 재검색용 추천 검색어 후보 (최대 12개) */
export const buildEmptyResultSearchSuggestions = (
  usedKeyword: string | null | undefined,
  draftDrugName: string | null | undefined,
): string[] => {
  const used = String(usedKeyword ?? '').trim();
  const draft = String(draftDrugName ?? '').trim();
  const seen = new Set<string>();
  const result: string[] = [];
  const pushOrdered = (s: string) => {
    const t = String(s ?? '').trim();
    if (!t || t === used || seen.has(t)) {
      return;
    }
    seen.add(t);
    result.push(t);
  };

  pushOrdered(draft);

  const hangulOnly = draft.replace(/[^\p{Script=Hangul}]/gu, '');
  pushOrdered(hangulOnly);

  const withoutParen = draft
    .replace(/\([^)]*\)/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  pushOrdered(withoutParen);

  const parts = draft.split(/\s+/).filter(Boolean);
  if (parts.length > 1) {
    parts.forEach((p) => pushOrdered(p));
  }

  const maxPrefix = Math.min(hangulOnly.length, 10);
  for (let n = maxPrefix; n >= 2; n -= 1) {
    if (hangulOnly.length >= n) {
      pushOrdered(hangulOnly.slice(0, n));
    }
  }

  return result.slice(0, 12);
};
